import { useMemo } from "react"
import { Select } from "components/ui/select/Select"
import type { TEref } from "types/elevationReferences.type"
import style from "./ElevationReferenceSelect.module.scss"

const { wrapper, labelRow, label, requiredMark } = style

type Props = {
	erefs: TEref[]
	value: number | null
	onChange: (value: number | null) => void
}

export const ElevationReferenceSelect = ({ erefs, value, onChange }: Props) => {
	const options = useMemo(() => {
		const sorted = erefs.slice().sort((a, b) => {
			const an = Number(a.elevation_number)
			const bn = Number(b.elevation_number)
			const aValid = Number.isFinite(an)
			const bValid = Number.isFinite(bn)
			if (aValid && bValid) return an - bn
			if (aValid) return -1
			if (bValid) return 1
			return String(a.elevation_number ?? "").localeCompare(String(b.elevation_number ?? ""))
		})
		return sorted.map((eref) => ({
			label: `${eref.elevation_number} — ${eref.page_name ?? "Unknown"}`,
			value: eref.id,
		}))
	}, [erefs])

	return (
		<div className={wrapper}>
			<div className={labelRow}>
				<span className={label}>Elevation reference</span>
				<span className={requiredMark}>*</span>
			</div>
			<Select
				variant="outlined"
				options={options}
				value={value}
				onChange={(next) => onChange(typeof next === "number" ? next : null)}
				placeholder="Select elevation reference"
				showSearch
				optionFilterProp="label"
				allowClear
				renderInPlace
			/>
		</div>
	)
}
